export default function () {
  const widgetName = 'generalSponsors';
  const widgetOpts = generalSponsorsOpts;


  if ($('body').hasClass('homepage') || $('body').hasClass('HC-Homepage')) {
    return saffire.widgets.sponsors($(`#${widgetName}`), {
      scriptPath: widgetOpts.scriptPath,
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      timePerSponsor: 2,
      bw: false,
      rotate: true
      
    });
  }



}